import React, { useContext } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { UserContext } from "../../App";
import getFirstAllowedRoute from "../../Utlis/GetFirstAllowedRoute";
import Select from "../../Pages/Public/Select";
import Dashboard from "../../Pages/FleetManager/Dashboard";
import Vehicles from "../../Pages/FleetManager/Vehicles";
import Drivers from "../../Pages/FleetManager/Drivers";
import CreditsBillings from "../../Pages/FleetManager/CreditsBillings";
import Transactions from "../../Pages/FleetManager/Transactions";
import Reports from "../../Pages/FleetManager/Reports";
import UserManagement from "../../Pages/FleetManager/UserManagement";
import SettingsPermissions from "../../Pages/FleetManager/SettingsPermissons";
import MyProfile from "../../Pages/FleetManager/MyProfile";
import FuelVendors from "../../Pages/FleetManager/FuelVendors";
import VehicleDetail from "../../Pages/FleetManager/Vehicles/VehicleDetail";
import AddVehicle from "../../Pages/FleetManager/Vehicles/AddVehicle";
import EditVehicle from "../../Pages/FleetManager/Vehicles/EditVehicle";
import AddDriver from "../../Pages/FleetManager/Drivers/AddDriver";
import DriverDetail from "../../Pages/FleetManager/Drivers/DriverDetail";
import UserDetails from "../../Pages/FleetManager/UserManagement/UserDetails";
import TransactionDetails from "../../Pages/FleetManager/Transactions/TransactionDetails";
import EditDriver from "../../Pages/FleetManager/Drivers/EditDriver";
import CreditAdjustmentsManager from "../../Pages/FleetManager/CreditsBillings/CreditAdjustments";
import AuditTrailManager from "../../Pages/FleetManager/AuditTrail";
import EditProfile from "../../Pages/FleetManager/CompanyDetail";
import SubscriptionPayments from "../../Pages/FleetManager/SubscriptionPayments";
import Subscription from "../../Pages/FleetManager/SubscriptionPayments/Subscription";
import MySubscription from "../../Pages/FleetManager/SubscriptionPayments/MySubscription";

const FleetManagerRoutes = ({ setUser }) => {
  const { userData } = useContext(UserContext);
  const location = useLocation();
  const fallbackRoute = userData?.subscription_payment_required
    ? "/my-subscription"
    : getFirstAllowedRoute(
        "manager",
        userData?.page_access,
        "/dashboard-manager",
      );

  const guard = (slug, redirectTo, element) => {
    const access = userData?.page_access?.[slug];
    const canEdit =
      access === undefined || access === null || access === "view_edit";
    return canEdit ? element : <Navigate to={redirectTo} replace />;
  };

  if (
    userData?.subscription_payment_required &&
    !["/my-subscription", "/selection"].includes(location.pathname)
  ) {
    return <Navigate to="/my-subscription" replace />;
  }

  return (
    <Routes>
      <Route path="/dashboard-manager" element={<Dashboard />} />

      <Route path="/vehicles-manager" element={<Vehicles />} />
      <Route path="/vehicle-detail" element={<VehicleDetail />} />
      <Route
        path="/add-vehicle"
        element={guard("vehicles", "/vehicles-manager", <AddVehicle />)}
      />
      <Route
        path="/edit-vehicle"
        element={guard("vehicles", "/vehicles-manager", <EditVehicle />)}
      />

      <Route path="/drivers-manager" element={<Drivers />} />
      <Route
        path="/add-driver"
        element={guard("drivers", "/drivers-manager", <AddDriver />)}
      />
      <Route
        path="/edit-driver"
        element={guard("drivers", "/drivers-manager", <EditDriver />)}
      />
      <Route path="/driver-detail" element={<DriverDetail />} />

      <Route path="/fuel-vendors-manager" element={<FuelVendors />} />

      <Route path="/credits-billings-manager" element={<CreditsBillings />} />
      <Route
        path="/credit-adjustments-manager"
        element={<CreditAdjustmentsManager />}
      />

      <Route path="/transactions-manager" element={<Transactions />} />
      <Route
        path="/transaction-manager-details"
        element={<TransactionDetails />}
      />

      <Route path="/subscription-payments" element={<SubscriptionPayments />} />
      <Route path="/subscription" element={<Subscription />} />
      <Route
        path="/my-subscription"
        element={<MySubscription setUser={setUser} />}
      />

      <Route path="/reports-manager" element={<Reports />} />
      <Route path="/user-management-manager" element={<UserManagement />} />
      <Route path="/user-detail" element={<UserDetails />} />
      <Route
        path="/settings-permissions-manager"
        element={<SettingsPermissions />}
      />

      <Route
        path="/profile-manager"
        element={<MyProfile setUser={setUser} />}
      />
      <Route path="/company-details" element={<EditProfile />} />

      <Route path="/audit-trail-manager" element={<AuditTrailManager />} />

      <Route path="/selection" element={<Select setUser={setUser} />} />
      <Route path="*" element={<Navigate to={fallbackRoute} />} />
    </Routes>
  );
};

export default FleetManagerRoutes;
